var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "room-setting-streaming-component p-5" }, [
    _c("div", { staticClass: "room-setting-content-box" }, [
      _c("h6", { staticClass: "room-setting-content-title" }, [
        _vm._v(_vm._s(this.$t("setting.streaming.title"))),
      ]),
      _c("div", { staticClass: "room-setting-content-text-box" }, [
        _c("p", { staticClass: "room-setting-content-text" }, [
          _vm._v(_vm._s(this.$t("setting.streaming.text"))),
        ]),
      ]),
      _vm._m(0),
      _vm._m(1),
      _vm._m(2),
      _vm._m(3),
      _vm._m(4),
      _vm._m(5),
      _vm._m(6),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "room-setting-input-box" }, [
      _c("label", { staticClass: "room-setting-label" }, [
        _c("input", {
          staticClass: "room-setting-radio",
          attrs: {
            type: "checkbox",
            name: "youtubeStreaming",
            value: "youtube",
          },
        }),
        _c("span", [_vm._v("Youtube")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "room-setting-input-box" }, [
      _c("input", {
        staticClass: "room-setting-input",
        attrs: { type: "text", name: "youtubeStreamingKey", placeholder: "" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "room-setting-input-box" }, [
      _c("label", { staticClass: "room-setting-label" }, [
        _c("input", {
          staticClass: "room-setting-radio",
          attrs: {
            type: "checkbox",
            name: "facebookStreaming",
            value: "facebook",
          },
        }),
        _c("span", [_vm._v("facebook")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "room-setting-input-box" }, [
      _c("input", {
        staticClass: "room-setting-input",
        attrs: { type: "text", name: "facebookStreamingKey", placeholder: "" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "room-setting-input-box" }, [
      _c("label", { staticClass: "room-setting-label" }, [
        _c("input", {
          staticClass: "room-setting-radio",
          attrs: { type: "checkbox", name: "externalStreaming", value: "etc" },
        }),
        _c("span", [_vm._v("기타")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "room-setting-input-box" }, [
      _c("input", {
        staticClass: "room-setting-input",
        attrs: {
          type: "text",
          name: "externalStreamingUrl",
          placeholder: "URL",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "room-setting-input-box" }, [
      _c("input", {
        staticClass: "room-setting-input",
        attrs: { type: "text", name: "externalStreamingKey", placeholder: "" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }